import {
    resourceCheckInStatusProjectionFactory,
    resourceCheckInStatusProjectionZodObject,
} from "@@/shared/statuses/reservation-check-ins/resource-check-in.status-projection";
import { assertTypeMatch } from "@@/utilities/type-helpers";
import type { z } from "zod";

const statusProjectionZodUnion = resourceCheckInStatusProjectionZodObject; // only one yet

type StatusProjection = z.infer<typeof statusProjectionZodUnion>;
type StatusProjectionType = StatusProjection["_type"];

// Assertions
// - Make sure all status projections have a _type property of type "STATUS_PROJECTION"
assertTypeMatch<
    StatusProjection extends { _type: "STATUS_PROJECTION" } ? true : false
>();
// - Make sure all status projections have a version property of type number
assertTypeMatch<StatusProjection extends { _version: number } ? true : false>();
// - Make sure all status projections have a type property of string type
assertTypeMatch<StatusProjection extends { type: string } ? true : false>();

const statusProjectionFactory = {
    resourceCheckInStatus: resourceCheckInStatusProjectionFactory,
};

export { statusProjectionFactory, statusProjectionZodUnion };
export type { StatusProjection, StatusProjectionType };
